var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('header', {
    staticClass: "row p12",
    staticStyle: {
      "background": "#f2f2f2"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "h-filter"
  }, [_vm.checkoutPermission('CREATE_UNIT_OF_MEASURE') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'CreateUnitOfMeasure'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New ")])]) : _vm._e()], 1)]), _c('div', {
    staticClass: "table-control"
  }, [_c('table', {
    staticClass: "table wh800",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w70 txt-center"
  }, [_vm._v("No")]), _c('th', [_vm._v("Name")]), _c('th', [_vm._v("Description")]), _vm.checkoutPermission('UPDATE_UNIT_OF_MEASURE') || _vm.checkoutPermission('DELETE_UNIT_OF_MEASURE') ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "100px"
    }
  }, [_vm._v(" Action ")]) : _vm._e()])]), !_vm.isFetching && _vm.checkoutPermission('LIST_UNIT_OF_MEASURE') ? _c('tbody', _vm._l(_vm.data.unitOfMeasure, function (unitOfMeasure, index) {
    return _c('tr', {
      key: (unitOfMeasure, index),
      staticClass: "hover-list"
    }, [_c('td', {
      staticClass: "txt-center"
    }, [_vm._v(_vm._s(unitOfMeasure === null || unitOfMeasure === void 0 ? void 0 : unitOfMeasure.id))]), _c('td', [_vm._v(_vm._s(unitOfMeasure.name))]), _c('td', [_vm._v(_vm._s(_vm.htmlToText(unitOfMeasure.description)))]), _c('td', {
      staticClass: "tr-right"
    }, [_vm.checkoutPermission('UPDATE_UNIT_OF_MEASURE') ? _c('router-link', {
      staticClass: "btn btn-info btn-xs mr5",
      attrs: {
        "to": {
          name: 'EditUnitOfMeasure',
          query: {
            id: unitOfMeasure.id
          }
        }
      }
    }, [_vm._v(" Update ")]) : _vm._e(), _vm.checkoutPermission('DELETE_UNIT_OF_MEASURE') ? _c('button', {
      staticClass: "btn btn-light-dark btn-xs",
      on: {
        "click": function ($event) {
          return _vm.popupModal(index);
        }
      }
    }, [_vm._v(" Delete ")]) : _vm._e()], 1)]);
  }), 0) : _vm._e()]), _vm.isFetching ? _c('TableLoading') : _vm._e(), _vm.isNoData ? _c('NoItem') : _vm._e()], 1), _c('div', {
    staticClass: "total ph12"
  }, [_c('div', {
    staticClass: "ul-xl-li go-left"
  }, [_vm._v("Total : " + _vm._s(_vm.data.pagination.total))]), _vm.data.pagination.totalPage > 0 ? _c('Pagination', {
    attrs: {
      "pagination": _vm.data.pagination.totalPage
    }
  }) : _vm._e()], 1)])]), _vm.display.modal.delete.show ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal-md"
  }, [_vm._m(1), _vm._m(2), _c('div', {
    staticClass: "modal-footer border-top"
  }, [!_vm.isDeleting ? _c('button', {
    staticClass: "btn btn-info btn-xs go-right",
    on: {
      "click": _vm.deleteUnitOfMeasure
    }
  }, [_vm._v(" Yes ")]) : _c('button', {
    staticClass: "btn btn-info btn-xs go-right"
  }, [_vm._v("Loading...")]), _c('button', {
    staticClass: "btn btn-light-secondary btn-xs mr12 go-right",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" No ")])])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "go-left",
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('b', [_vm._v("Unit of Measurement ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-header border-bottom txt-info"
  }, [_c('span', {
    staticClass: "txt-sm"
  }, [_vm._v("Delete")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "hidden",
      "padding": "16px"
    }
  }, [_c('span', [_vm._v("Do you want to delete this record?")])]);

}]

export { render, staticRenderFns }